//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import listItem from '@/components/donateTogether/listItem'
	export default{
		components: {
			listItem
		},
		props:['epId'],
		data() {
			return {
				rankType: [{id: 1, name: '进行中'}, {id: 2, name: '已完成'}],
				typeBoolean: false,
				queryState: 1,//查询状态 1是进行中，2是已完成
				isFirst: true, //是否第一次切换
				finishList: [], //已完成数据
				unfinishList: [], //进行中数据
				sortIndex:1,
				typeIndex:0,
				listTotal:''
			}
		},
		methods: {
			tab(index) {
				if(this.typeIndex !== index){
					this.typeBoolean = !this.typeBoolean
					this.typeIndex = index
					if(index==0) {
		        this.queryState = 1;
		      }else {
		        this.queryState = 2;
		      }
					if(this.isFirst) {
						this.isFirst = false
						this.getList()
					}
				}
			},
			refresh (done) {
		  	setTimeout(() => {
		  		this.sortIndex = 1
			   	if(this.queryState == 1){
			   		this.unfinishList = []
			   	}else {
			   		this.finishList = []
			   	}
			 		this.getList();
			 		done()
		  	}, 1000)
			   	// this.sortIndex = 1
				   // 	if(this.queryState == 1){
				   // 		this.unfinishList = []
				   // 	}else {
				   // 		this.finishList = []
				   // 	}
				 		// this.getList(done);
				 		// done(true)
			},
			infinite (done) {
		 		setTimeout(() => {
		 			if(this.queryState == 1){
			   		if(this.unfinishList.length < this.listTotal) {
			   			this.sortIndex++
			 				this.getList(done);
			   		}else {
			   			done(true)
			   		}
			   	}else {
			   		if(this.finishList.length < this.listTotal) {
			   			this.sortIndex++
			 				this.getList(done);
			   		}else {
			   			done(true)
			   		}
			   		
			   	}
		 			
		 		}, 1000)
			},
			getList(done) {
				let data = {
	        epId: this.epId,
	        finished: this.queryState,
	        pageIndex:this.sortIndex,
	        pageSize: 10
	      }
	      this.$https.post(this.BASE_URL+"grd/groupDonation/listOfGroupDonationByCreatorID",
	        data
	      )
	      .then(res => {
	      	this.listTotal = res.data.data.total
	      	if(this.queryState === 1) {
	      		// 进行中
	        	this.unfinishList.push(...res.data.data.records)
	      	}else {
	      		// 已完成
	        	this.finishList.push(...res.data.data.records)
	      	}
	      	if(done){
	       		done(true)
	       	}
	      })
	      .catch(function(err) {
	      	console.log(err);
	      })
			}
		},
		created() {
			this.getList()
		}
	}



// WEBPACK FOOTER //
// ./src/crowd_fund/mydtList.vue